<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">School schedule</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
			<v-alert type="info" dense outlined class="mb-0">
				Functionaliteit volgt in een volgende stap.
			</v-alert>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: "SchoolSchedule"
};
</script>
